import { LOADING } from "../../../constants/constant";
import {
  GET_ALL_CARRIER_AND_COUNTRY_LIST_REQUESTED,
  GET_ALL_CARRIER_AND_COUNTRY_LIST_FAILED,
  GET_ALL_CARRIER_AND_COUNTRY_LIST_SUCCESS,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getAllCarrierAndCountryDetailsReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GET_ALL_CARRIER_AND_COUNTRY_LIST_REQUESTED:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case GET_ALL_CARRIER_AND_COUNTRY_LIST_SUCCESS:
      let userRes = Object.assign({}, state);
      userRes.status = action.data.status_message;
      userRes.isLoading = false;
      userRes.statusCode = action.data.status_code;

      if (userRes.statusCode === 10) {
        userRes.error = false;
        userRes.carrierList = action.data.data.carrier_list;
        userRes.countryList = action.data.data.country_list;
        userRes.isRequestSubmitted = false;
      } else {
        userRes.error = true;
        userRes.errorMessage = action.data.message;
      }
      return userRes;

    case GET_ALL_CARRIER_AND_COUNTRY_LIST_FAILED:
      return Object.assign({}, state, action.error);

    default:
      return state;
  }
}
